import * as React from 'react';
import { useCarouselContext } from '../CarouselProvider/CarouselProvider';
import S from './LiveRegion.styles';
const LiveRegion = React.forwardRef((props, ref) => {
    const carousel = useCarouselContext();
    return (React.createElement(S.Container, { ...props, ref: ref, "aria-live": "polite", "aria-atomic": "true" },
        carousel.activeIndex + 1,
        " of ",
        carousel.maxIndex + 1));
});
LiveRegion.displayName = 'LiveRegion';
export default LiveRegion;
